import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-quota-bar',
  standalone: true,
  template: `
    <div class="quota-track" [style.height.px]="height" [style.background]="trackColor">
      <div
        class="quota-fill"
        [style.width.%]="clampedPct"
        [style.border-radius.px]="height / 2"
      ></div>
      @if (prevPct != null && prevPct! > 0 && prevPct! < pct) {
        <div class="quota-prev-marker" [style.left.%]="prevPct"></div>
      }
      <div class="quota-alert-marker" [style.left.%]="80"></div>
    </div>
  `,
  styles: [
    `
      .quota-track {
        position: relative;
        width: 100%;
        background: #e5e5ea;
        border-radius: 999px;
        overflow: hidden;
      }
      .quota-fill {
        height: 100%;
        background: #2463eb;
        min-width: 12px;
      }
      .quota-prev-marker {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 2px;
        background: #ffffff;
        transform: translateX(-50%);
      }
      .quota-alert-marker {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 2px;
        background: #e8a317;
        transform: translateX(-50%);
        z-index: 2;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotaBarComponent {
  @Input({ required: true }) pct = 0;
  @Input() prevPct?: number | null;
  @Input() height = 12;
  @Input() trackColor = '#e5e5ea';
  @Input() set track(t: string) {
    this.trackColor = t;
  }

  get clampedPct(): number {
    return Math.max(0, Math.min(100, this.pct));
  }
}
